import axios from "axios";

function getHashCode(s) {
  let hash = 0,
    c = typeof s === "string" ? s.length : 0,
    i = 0;

  while (i < c) {
    hash = (hash << 5) - hash + s.charCodeAt(i++);
  }

  return hash < 0 ? hash * -1 + 0xffffffff : hash; /* convert to unsigned int */
}
const authTokenPayload = (payload) => {
  const refer = `bangdb_app_store`;
  const ts = (Date.now() * 1000)?.toString();
  const secret = process.env.REACT_APP_TOKEN_AUTH_SECRET;

  const authPayload = {
    ...payload,
    refer,
    ts,
    token: getHashCode(refer + ts + secret)
  };

  return authPayload;
};
const userServiceBaseUrl = process.env.REACT_APP_USER_API || "testuser.bangdb.com:18080";

const headers = {
  "Content-Type": "application/json; charset=UTF-8"
  //   'x-bang-api-key': userInfo.apikey,
};

const get_api_headers = () => {
  let userInfo = null;

  try {
    userInfo = JSON.parse(sessionStorage.getItem("userInfo") || {});
  } catch (error) {
    // console.log(error)
  }

  return {
    "Content-Type": "application/json",
    "x-bang-api-key": userInfo?.apikey
  };
};

const userService = axios.create({
  baseURL: `https://${userServiceBaseUrl}`,
  headers,
  timeout: 15000
});

const cloudService = axios.create({
  baseURL: `https://${process.env.REACT_APP_CLOUD_SERVICE}`,
  headers: {
    "Content-Type": "application/json"
  }
});

const provisionService = axios.create({
  baseURL: `https://${process.env.REACT_APP_PROVISION_API || `testprovision.bangdb.com:18080`}`,
  headers: get_api_headers()
});

export const createUser = async (json) => {
  const res = await userService.post("/user/create", json);
  return res.data;
};

export const createApiKey = async (json) => {
  const res = await userService.post("/user/create_api_key", json);
  return res.data;
};

export const addServerInfo = async (json) => {
  const res = await userService.post("/user/add_server_info", json);
  return res.data;
};

export async function getUserInfo(userid, apiKey, service) {
  if (typeof window === "object") {
    const newInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    if (service) {
      const res = await axios.post(
        `${
          typeof window === "object" ? window?.location?.protocol : "http:"
        }//${service}/user/info`,
        {
          userid,
          apikey: apiKey
        },
        {
          headers: {
            "x-bang-api-key": newInfo?.apikey
          }
        }
      );
      return res.data;
    } else {
      const res = await userService.post(
        "/user/info",
        {
          userid,
          apikey: apiKey
        },
        {
          headers: {
            "x-bang-api-key": newInfo?.apikey
          }
        }
      );
      return res.data;
    }
  }
}

export const createNewRazorPayOrder = async (payload) => {
  const res = await provisionService.post("/user/subscriptions", authTokenPayload(payload));
  return res.data;
};

export const login = async (userid, pwd) => {
  const res = await userService.post("/user/authenticate_user", {
    userid,
    pwd
  });
  return res.data;
};

export const addOauthInfo = async (payload) => {
  const res = await userService.post("/user/add_oauth", payload);
  return res.data;
};

export const userInfo = async (payload) => {
  const res = await userService.post("/user/info", payload);
  return res.data;
};

export const getServerPoolInfo = async (payload) => {
  const res = await userService.post("/user/get_pool_info", payload);
  return res.data;
};

export const updateServerPoolInfo = async (payload) => {
  const res = await userService.post("/user/put_pool_info", payload);
  return res.data;
};

export const updateAccountInfo = async (payload) => {
  const res = await userService.post("/user/add_account_info", payload);
  return res.data;
};
export const getAccountInfo = async (payload) => {
  const res = await userService.post("/user/get_account_info", payload);

  return res.data;
};

export const deleteServerPoolInfo = async (payload) => {
  const res = await userService.post("/user/del_pool_info", payload);
  return res.data;
};

export const authLogin = async (payload) => {
  const res = await userService.post("/user/authenticate_user", payload);
  return res.data;
};

export const changePassword = async (payload) => {
  const res = await userService.post("/user/change_pwd", payload);
  return res.data;
};

export const provisionSaasServer = async (payload) => {
  if (typeof window === "object") {
    const newInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const res = await provisionService.post("/user/provision", payload, {
      headers: {
        "x-bang-api-key": newInfo?.apikey
      }
    });

    return res.data;
  }
};

export const getProvisioningStatus = async (payload) => {
  if (typeof window === "object") {
    const newInfo = JSON.parse(sessionStorage.getItem("userInfo"));

    const res = await provisionService.post("/user/provision_log", payload, {
      headers: {
        "x-bang-api-key": newInfo?.apikey
      }
    });

    return res.data;
  }
};

export const addSupportIssue = async (payload) => {
  // const forumkey = sessionStorage.getItem("forum_admin_api_key")
  //   ? JSON.parse(sessionStorage.getItem("forum_admin_api_key"))
  //   : "";

  const getSupportApiKey = async (pld) => {
    const resp = await axios.post(
      `https://${
        process.env.REACT_APP_SUPPORT_BASE_URL || "testbe.bangdb.com:18080"
      }/user/get_api_key`,
      pld
    );
    return resp.data;
  };

  const pload = authTokenPayload({ userid: "forum_admin" });
  const resp = await getSupportApiKey(pload);
  const job = await authTokenPayload(payload);
  const res = await axios.post(
    `https://${
      process.env.REACT_APP_SUPPORT_BASE_URL || "testbe.bangdb.com:18080"
    }/db/mydb/work/put_work`,
    job,
    {
      headers: {
        "x-bang-api-key": resp.apikey,
        "x-bang-api-src": "opaque"
      }
    }
  );
  return res.data;
};

export const getRazorPayKey = async () => {
  const res = await provisionService.post("/user/get_razorpay_key", authTokenPayload({}));
  return res.data;
};

export const addSubscriptionTransaction = async (json) => {
  const res = await userService.post("/user/subscription_txn", json, {
    headers: get_api_headers()
  });
  return res.data;
};

export const addAccountOrder = async (json) => {
  const res = await userService.post("/user/account_order_op", json, {
    headers: get_api_headers()
  });

  return res.data;
};

export const getSubscriptions = async (json) => {
  const res = await userService.post("/user/get_users", json, {
    headers: get_api_headers()
  });

  return res.data;
};

export const createBillingCustomer = async (payload) => {
  try {
    const res = await cloudService.post("/billing/subscriptions", {
      url: `/customers`,
      method: "POST",
      ...payload
    });

    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const createSubscription = async (payload) => {
  try {
    const res = await cloudService.post("/billing/subscriptions", {
      url: `/subscriptions`,
      method: "POST",
      ...payload
    });

    return res.data;
  } catch (error) {
    console.error(error);
  }
};

export const putWork = (ip, payload, dbname) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/put_work`, payload, {
    headers: {
      "x-bang-api-key": 9
    }
  });

export const putWorkMessage = (ip, payload, dbname, apikey) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/put_msg`, payload, {
    headers: {
      "x-bang-api-key": apikey,
      "x-bang-api-src": "opaque"
    }
  });

export const scanWork = (ip, payload, dbname) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/scan_work`, payload, {
    headers: {
      "x-bang-api-key": 9
    }
  });

export const getJobsWithIds = (ip, payload, dbname) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/get_jobs`, payload, {
    headers: {
      "x-bang-api-key": 9
    }
  });

export const deleteWork = (ip, payload, dbname) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/delete`, payload, {
    headers: {
      "x-bang-api-key": 9
    }
  });

export const scanWorkMessage = (ip, payload, dbname, apikey) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/scan_msg`, payload, {
    headers: {
      "x-bang-api-key": apikey,
      "x-bang-api-src": "opaque"
    }
  });

export const workCypher = (ip, payload, dbname, apikey) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/cypher`, payload, {
    headers: {
      "x-bang-api-key": apikey,
      "x-bang-api-src": "opaque"
    }
  });

export const workUserAction = (ip, payload, dbname, apikey) =>
  axios.post(`https://${ip}:18080/db/${dbname}/work/user_action`, payload, {
    headers: {
      "x-bang-api-key": apikey,
      "x-bang-api-src": "opaque"
    }
  });
